// CSS
import styles from "./loading-section.module.scss";

// Const
const loadingSpinnerSrc =
    require("../../assets/images/loading-spinner-transparent.gif").default;

export const LoadingSection = (props) => {
    return (
        <div className={styles["loading-section"]}>
            <img
                alt="Loading spinner"
                className={styles.spinner}
                src={loadingSpinnerSrc}
            />
        </div>
    );
};
